// extracted by mini-css-extract-plugin
module.exports = {"instructions":"IBOLogin_instructions__PmkT2"};